import axios from '../library/axiosConfig';

export default {
  roomDistrictAndSubway(data) {
    return axios.post('/h5/find/v1/rooms/landlord/roomDistrictAndSubway', data, {baseURL: axios.defaults.custSeek, brandCustom: true})
  },
  rooms(data) {
    return axios.post('/h5/find/v1/rooms/landlord/rooms', data, {baseURL: axios.defaults.custSeek, brandCustom: true})
  },
  roomCitys(data) {
    return axios.post('/h5/find/v1/rooms/landlord/roomCitys', data, {baseURL: axios.defaults.custSeek, brandCustom: true})
  },
  /**
   * 品牌定制品牌logo
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getLandlordLogo(data) {
    return axios.post(`/h5/find/v1/rooms/landlord/getLandlordLogo`, data, {baseURL: axios.defaults.custSeek, brandCustom: true})
  },
  /**
   * 渠道埋点
   * @param data
   * @returns {AxiosPromise<any>}
   */
  incrCustomBrandPV(data) {
    return axios.post('/h5/find/v1/rooms/incrCustomBrandPV', data, {baseURL: axios.defaults.custSeek, brandCustom: true})
  },
  // 特价房
  getCustomActivityRooms (data) {
    return axios.post('/app/activity/v1/search/getCustomActivityRooms', data, {baseURL: axios.defaults.custSeek})
  },
  // 房东电话
  getLandlordTele (roomId, sourceType) {
    return axios.post('/app/activity/v1/getLandlordTele', {roomId, sourceType}, {baseURL: axios.defaults.custSeek})
  },
  // 专题活动
  getTopicActivityRooms (data) {
    return axios.post('/app/activity/v1/search/getTopicActivityRooms', data, {baseURL: axios.defaults.custSeek})
  }
}



// WEBPACK FOOTER //
// ./src/api/custSeek.js